import service from "@/api/service";
import { GetResponse } from "@/api/stamp-preview/response";
import { GetRequest } from "@/api/stamp-preview/request";

/**
 * スタンプカードプレビュー取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/stamp-preview", getRequest);
  return response.data as GetResponse;
}
